import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppNavbar } from './components/navbar/Navbar';
import { HomePage } from './components/homepage/HomePage';
import { About } from './components/about/About';
import { NotImplemented } from './components/not-implemented/NotImplemented';
import { CarDetailsPage } from './components/carDetails/CarDetailsPage';
import { ErrorPage } from './components/error/Error';
import { BrandList } from './components/brandList/BrandList';
import { ModelList } from './components/modelList/ModelList';
import { BestCarsPage } from './components/reliability/BestCarsPage';
import { ReliabilityDataPage } from './components/reliability/ReliabilityDataPage';

const META_DESCRIPTION =
  'Your Go-To Source for Informed Car Purchases: Navigate the Auto Market with Data-Driven Insights. Explore comprehensive statistics, reported issues, and market trends for various car models. From uncovering the most reliable options to understanding common problems, we equip you with valuable information to make confident and informed decisions on your next vehicle purchase.';

function App() {
  return (
    <div className="App">
      <meta name="description" content={META_DESCRIPTION} />
      <BrowserRouter>
        <AppNavbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/cars" element={<BrandList />} />
          <Route path="/cars/:make" element={<ModelList />} />
          <Route path="/cars/:make/:model" element={<CarDetailsPage />} />
          <Route path="/best-cars" element={<BestCarsPage />} />
          <Route path="/reliability" element={<ReliabilityDataPage />} />
          <Route path="/not-implemented" element={<NotImplemented />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
